import React, { useMemo } from 'react';
import {
  createSelectApplyFilterToProduct,
  makeSelectProductById,
} from 'core/redux/features/products/reducers/products';
import { useSelector } from 'react-redux';
import { AppState } from 'core/redux/reducers';
import { ProductId } from 'core/redux/features/shared/types';
import NoStockOverlayText from './NoStockOverlayText';
import { IProduct } from 'core/redux/features/products/types';
import FilterOverlayText from './FilterOverlayText';

interface IProps {
  productId: ProductId;
}

export default function OverlayTextDecider({ productId }: IProps) {
  const selectApplyFilterToProduct = useMemo(
    createSelectApplyFilterToProduct,
    [],
  );

  const selectProductById = useMemo(makeSelectProductById, []);
  const product: undefined | IProduct = useSelector((state: AppState) =>
    selectProductById(state, productId),
  );

  const results: string[] | boolean = useSelector((state: AppState) => {
    if (product?.status !== 'in-stock') {
      return false;
    }

    return selectApplyFilterToProduct(state, productId);
  });

  if (!product) {
    return null;
  }

  // sold out overlay
  if (results === false) {
    return <NoStockOverlayText product={product} />;
  }

  if (results.length === 0) {
    return null;
  }

  return <FilterOverlayText filterResult={results} />;
}
